import React, { useEffect } from 'react';

import { UseFormReturn } from 'react-hook-form';

import { useAppSelector } from 'prequalificationV2/hooks/useAppSelector';
import { BorrowerRole } from 'enums/BorrowerRole';
import {
  CurrentEmploymentVariable,
  EmploymentStatusInformationInputLabel,
} from 'prequalificationV2/pages/Dashboard/steps/InformationTabs/AdditionalInformationTab/additionalInformation.enums';
import { getEmploymentVariableName } from 'prequalificationV2/pages/Dashboard/steps/InformationTabs/AdditionalInformationTab/additionalInformation.utils';
import Select from 'components/Select';
import { GOVERNMENT_PAYGRADE_OPTIONS } from 'prequalificationV2/pages/Dashboard/steps/InformationTabs/AdditionalInformationTab/additionalInformation.constants';
import { getErrorMessageForRequiredFields } from 'prequalificationV2/utils/stringUtils';
import styles from 'prequalificationV2/pages/Dashboard/steps/InformationTabs/InformationTabs.module.scss';

const GovernmentInformation = ({
  formMethods,
  borrowerType,
  watcher,
}: {
  formMethods: UseFormReturn<any, any>;
  borrowerType: BorrowerRole;
  watcher: any;
}) => {
  const { variables } = useAppSelector((state) => state.application);
  const applicationVariables = variables!;

  const {
    register,
    clearErrors,
    formState: { errors },
    setValue,
  } = formMethods;

  useEffect(() => {
    register(getEmploymentVariableName(CurrentEmploymentVariable.GovernmentPaygrade, borrowerType), {
      required: {
        value: !watcher[getEmploymentVariableName(CurrentEmploymentVariable.GovernmentPaygrade, borrowerType)],
        message: getErrorMessageForRequiredFields(EmploymentStatusInformationInputLabel.GovernmentPaygrade),
      },
    });
  }, []);

  return (
    <div className={styles.formRow}>
      <Select
        name={getEmploymentVariableName(CurrentEmploymentVariable.GovernmentPaygrade, borrowerType)}
        label={EmploymentStatusInformationInputLabel.GovernmentPaygrade}
        value={GOVERNMENT_PAYGRADE_OPTIONS.find(
          (options) =>
            options.label ===
            watcher[getEmploymentVariableName(CurrentEmploymentVariable.GovernmentPaygrade, borrowerType)],
        )}
        inputContainerClassName={styles.input}
        onChange={(value) => {
          clearErrors(getEmploymentVariableName(CurrentEmploymentVariable.GovernmentPaygrade, borrowerType));
          setValue(getEmploymentVariableName(CurrentEmploymentVariable.GovernmentPaygrade, borrowerType), value);
        }}
        options={GOVERNMENT_PAYGRADE_OPTIONS}
        errorMessage={
          errors[getEmploymentVariableName(CurrentEmploymentVariable.GovernmentPaygrade, borrowerType)]?.message
        }
        isClearable
        isDisabled={
          !!applicationVariables?.[
            getEmploymentVariableName(CurrentEmploymentVariable.GovernmentPaygrade, borrowerType)
          ]
        }
      />
    </div>
  );
};

export default GovernmentInformation;
